import React, {useEffect, useState} from "react";
import { useNavigate } from 'react-router-dom';
import instance from "../../services/services";
import { DISCOUNT_BENEFIT_LIST_URL } from "../../utils/urls";
import { useLanguage } from "../../hooks/useLanguage";

function DiscountBenefits(){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [discountType, setDiscountType] = useState([]);
  const [discountmGroup, setDiscountmGroup] = useState([]);

  useEffect(()=> {
    const getDiscountBenefits = async () => {
      try {
        const response = await instance.post(DISCOUNT_BENEFIT_LIST_URL);
        setDiscountType(response.data.data.mType);
        setDiscountmGroup(response.data.data.mGroup);
      } catch (error) {
        console.error("할인혜택 데이터 가져오기 실패:", error);
      }
    };
    getDiscountBenefits();
  }, []);

  useEffect(() => {
    const existingStyle = document.getElementById('dynamic-grade-styles');
    if (existingStyle) {
      existingStyle.remove();
    }
    
    const styleEl = document.createElement('style');
    styleEl.id = 'dynamic-grade-styles';
    
    let styleRules = '';
    discountmGroup.forEach((item, index) => {
      styleRules += `
        .grade-${index}::before {
          content: '${item?.group_name}';
          background-color: ${item?.group_color || '#6E49A5'} !important;
          display: inline-block;
          margin-right: 8px;
          color: #fff;
          font: var(--body1-1);
          padding: 3px 8px;
          border-radius: 4px;
        }
      `;
    });
    
    styleEl.textContent = styleRules;
    document.head.appendChild(styleEl);
    
    return () => {
      if (styleEl) document.head.removeChild(styleEl);
    };
  }, [discountmGroup]);
  
  return(
    <section className="guide_section benefit_section">
      <h3 className="commu_title noline">{t('discount_info')}</h3>
      <div className="apply_guide">
        <h4>{t('member_type_discount')}</h4>
        <ul className="benefit_info_list icon_box">
          {discountType.map((item, index) => (
          <li className="border_box" key={index}>
            <i className={`${
              item?.mtype_name === '학생' ? 'student_icon' : 
              item?.mtype_name === '촬영감독' ? 'cinematographer_icon' : 
              item?.mtype_name === '제작사' ? 'producer_icon' : 
              'cinematographer_icon'
            } grade_icon`}></i>
            <p className="grade_name">{item?.mtype_name}</p>
            <div className="text_con">
              <div className="info default_info">
                <h6>{t('member_type_condition')}</h6>
                {item?.mtype_name === '학생' && (
                  <>
                    <p>{t('recent_3_months')}<br />
                    {t('highest_validity_period')}</p>
                  </>
                )}
                {item?.mtype_name === '촬영감독' && (
                  <>
                    <p>{t('recent_12_months')}<br />
                    {t('contract_director')}</p>
                  </>
                )}
                {item?.mtype_name === '제작사' && (
                  <>
                    <p>{t('long_term_contract_condition_2')}<br />
                    {t('highest_validity_period_12')}</p>
                  </>
                )}
                <p>
                  {t('immediate_discount', {count: item?.rental_rate})}%<br />
                  {t('normal_return', {count: item?.point_rate})}%<br />
                  {t('sale_order_immediate_discount', {count: item?.sale_rate})}<br />
                </p>
              </div>
              <div className="percent">{item?.rental_rate}%</div>
            </div>
          </li>
          ))}
        </ul>
      </div>

      <div className="apply_guide">
        <h4>{t('member_type_discount_2')}</h4>
        <ul className="benefit_info_list no_icon_box">
          {discountmGroup.map((item, index) => (
          <li className="border_box" key={index}>
            <div className="flex-center-8">
              <p className={`grade_name grade-${index}`}>{item?.group_name}{t('rating_txt')}</p>
            </div>
            <div className="text_con">
              <div className="info" style={{display:"inline-block"}}>
                <h6>{t('member_type_condition')}</h6>
                <p>{t('member_type_condition_2')}</p> 
                {item?.order_price_use === 'Y' && (
                  <p>{t('monthly_rental_order_amount', {count: item?.group_order_price})}</p>
                )}
                {item?.group_order_cnt === 0 && (
                  <p>{t('monthly_rental_order_count',{count: item?.group_order_cnt})}</p>
                )}
                {item?.group_valid_days === 0 && (
                  <p>{t('validity_period', {count: item?.group_valid_days})}</p> 
                )}
                <p style={{marginTop:"8px"}}>
                  {t('immediate_discount', {count: item?.rental_reward_rate})}% <br />
                  {t('normal_return', {count: item?.rental_reward_rate})}% <br />
                  {t('sale_order_immediate_discount', {count: item?.sale_discount_rate})}
                </p>
              </div>
              <div className="percent">{item?.rental_discount_rate}%</div>
            </div>
          </li>
          ))}
        </ul>
      </div>
      <div className="submit_box">
        <button
          className="default_btn lg black mt_32"
          type="button"
          onClick={() => navigate('/myPage')}
          >
          {t('my_page_shortcut')}
        </button>
      </div>
    </section>
  )
};

export default DiscountBenefits;